export const LANG_CHANGE = 'LANG_CHANGE'
